import { useQuery, UseQueryResult } from 'react-query';
import pDebounce from 'p-debounce';

import { getTokenWithType } from './useAuth';

import { getCustomTableWithRecords } from '../utils/urls';

import { CustomTableWithRecords } from 'types/customTables';
import { ErrorModal } from 'types/modalTypes';

async function fetchCustomTableDetails({
  accountId,
  lookupId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getCustomTableWithRecords(accountId, lookupId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

const debouncedFetch = pDebounce(fetchCustomTableDetails, 500);

type TError = ErrorModal;

type TResult = {
  Data: CustomTableWithRecords | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  lookupId: number;
};

function useGetCustomTableWithRecords({
  accountId,
  lookupId,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_custom_table_with_records', accountId, lookupId],
    async () => {
      if (lookupId)
        return await debouncedFetch({
          accountId,
          lookupId,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetCustomTableWithRecords };
